/**
 * Loader for loading states
 */
class Loader {
  render() {
    return `
      <div class="spinner">
        <div class="icon-spinner"></div>
      </div>
    `;
  }
}

export { Loader };
